<p *ngIf="error" role="alert" class="text-danger">{{ error }}</p>
<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <tt-content-switcher [ttSelectedId]="page.gb_srfollowups_main" (ttSelectedIdChange)="onViewChanged($event)">
            <tt-switch ttId="OPEN" ttText="gb_srfollowups_main_open"></tt-switch>
            <tt-switch ttId="CLOSED" ttText="gb_srfollowups_main_closed"></tt-switch>
            <tt-switch ttId="ALL" ttText="gb_srfollowups_main_all"></tt-switch>
        </tt-content-switcher>
        <tt-date-range ttLabel="date_fom_tom" [ttModel]="page" (ttModelChange)="onDatesChanged($event)"></tt-date-range>
        <tt-input ttLabel="filterval" [ttModel]="page.filterval" (ttModelChange)="onFilterChanged($event)" ttShowClearButton></tt-input>
        <tt-checkbox ttLabel="show_sub_resources" [ttModel]="page.show_sub_resources" (ttModelChange)="onSubResourcesChanged($event)"></tt-checkbox>
    </tt-card>
    <tt-list [ttData]="items" [ttFilter]="page.filterval" ttBackStyle [ttGoto]="false" (ttClick)="openItem($event)"></tt-list>
</tt-page>
